import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import configureStore from './store';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'react-app-polyfill/ie11';
import './Resources/css/spinner.css';


const MainIndex=(
  <Provider store={configureStore()}>
  <BrowserRouter>
      <App/>
  </BrowserRouter>
  </Provider>
   )

ReactDOM.render(MainIndex, document.getElementById('root'));

